import { AxiosResponse } from 'axios';
import { User, UserResponse } from 'Models/User';
import { getAxiosInstance } from 'Utils/Http/ApiManager';
import { ApiUrl, getApiUrl } from 'Utils/Http/ApiUrls';

export interface PostUserResponse {
	user: UserResponse;
}

export interface PostUserRequest extends Omit<User, 'organization'> {
	password: string;
}

const postUser = async (token: string | null, user: PostUserRequest): Promise<AxiosResponse<PostUserResponse>> => {
	const url = getApiUrl(ApiUrl.Users);
	const axios = getAxiosInstance(token);
	return axios.post<PostUserResponse>(url, user);
};

export default postUser;
